var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrowserError404 = function SvgBrowserError404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 6V1.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v3M.5 11.5v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V12M.5 3.5h13M3.478 9.474H.839a.264.264 0 0 1-.198-.437l2.4-2.743a.25.25 0 0 1 .437.165zm0 0h.726m-.726 0v1.088M12.699 9.474H10.06a.264.264 0 0 1-.198-.437l2.4-2.743a.25.25 0 0 1 .437.165zm0 0h.725m-.725 0v1.088M5.549 7.267v2.237c0 .585.474 1.059 1.058 1.059h.786c.584 0 1.058-.474 1.058-1.059V7.267c0-.584-.474-1.058-1.058-1.058h-.786c-.584 0-1.058.474-1.058 1.058"
  }))));
};
export default SvgBrowserError404;